import { CentrifugalManagerService } from "@/core/services/websocket/CentrifugalManagerService"
import { useEffect, useState } from "react"

export default function useCentrifugeManagerService() {

    const [socketManager, setSocketManager] = useState<CentrifugalManagerService>()

    useEffect(() => {
        if(typeof document !== "undefined" && typeof (document as any).CentrifugeProvider !== "undefined") {
            setSocketManager((document as any).CentrifugeProvider)
        }
    }, [])

    return {
        socketManager
    }
}